const DraggableSection = () => {

    return (
        <div style={{ transition: "var(--transition)" }} className="tasks p-2 d-flex d-flex-between flex-wrap">

        </div>
    )
}

export default DraggableSection;